import ___default, { includes } from "lodash";
import { ofType, combineEpics } from "redux-observable";
import history from "@ane/core/lib/CreateHistory";
import { produceUserContextRouteQueryStringEpics } from "@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics";
import { setSearchContext } from "./actions.js";
import { ACTION_TYPES, FEATURE_SEARCH_REDUCER_KEYS } from "./constants.js";
import { EXP_QUERY_STRINGS } from "@ane/core/lib/constants/QueryString.constants";
import { featureSearchContextParams } from "./types.js";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import FeatureResource from "@ane/exp-data/lib/resources/expapiunified/Feature.resource";
import { getFormattedDateTime } from "@ane/exp-data/lib/resources/expapiunified/ExpApiVUnified.utils";
import { pairwise, filter, switchMap } from "rxjs/operators";
import { Observable } from "rxjs";
import { selectExperimentationGroupsAsync, selectFeatures, selectFeatureSearchContext } from "./selectors.js";
import { requestCompleted, requestNotStarted, requestFailed } from "@ane/core/lib/models";
import ExperimentationGroupResource from "@ane/exp-data/lib/resources/expapiunified/ExperimentationGroup.resource";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const getExperimentationGroupsEpicReducer = loadResourcesUtils({
  actionPrefix: ACTION_TYPES.LOAD_EXPERIMENTATION_GROUPS,
  dontLoad: (inputPayload, state) => {
    var _a;
    const { status } = (_a = selectExperimentationGroupsAsync(state, inputPayload)) != null ? _a : {};
    return requestCompleted(status);
  },
  reduxKeyNested: (workspaceId) => [FEATURE_SEARCH_REDUCER_KEYS.experimentationGroups, workspaceId],
  loadResource: (workspaceId) => ExperimentationGroupResource.getExperimentationGroups(workspaceId),
  onCompleteSuccess: (result) => {
    return result.value;
  }
});
const searchFeaturesEpicReducer = loadResourcesUtils({
  actionPrefix: ACTION_TYPES.LOAD_FEATURES,
  reduxKeyNested: () => [FEATURE_SEARCH_REDUCER_KEYS.items],
  loadResource: (payload) => {
    if (payload.workspaceId && payload.filters.experimentationGroup) {
      return FeatureResource.getFeatures(payload.workspaceId, payload.filters);
    }
  },
  onCompleteSuccess: (result) => result.value
});
const searchFeaturesFromContextEpic = (action$, state$) => action$.pipe(
  ofType(ACTION_TYPES.SET_CONTEXT),
  pairwise(),
  filter(([prevValue, value]) => {
    const status = selectFeatures(state$.value).status;
    return requestNotStarted(status) || requestFailed(status) || !___default.isEqual(prevValue.payload, value.payload);
  }),
  switchMap(([, { payload }]) => {
    return Observable.of(
      searchFeaturesEpicReducer.actionCreators.load({
        workspaceId: payload.workspaceId,
        filters: {
          top: payload.pageSize,
          skip: (payload.page - 1) * payload.pageSize,
          keywordSearch: payload.keywordSearch,
          subscriber: payload.subscriber,
          experimentationGroup: payload.experimentationGroup.length === 1 ? payload.experimentationGroup[0] : payload.experimentationGroup,
          isolationGroups: payload.isolationGroups,
          status: payload.statuses,
          fromDateTime: getFormattedDateTime(payload.startedAfter),
          toDateTime: getFormattedDateTime(payload.startedBefore),
          isArchived: payload.isArchived,
          collapseRolloutTargetsIntoRoot: payload.collapseRolloutTargetsIntoRoot,
          onlyLoadFeatureData: payload.onlyLoadFeatureData
        }
      })
    );
  })
);
const produceFeatureSearchRouteQueryStringSyncEpics = (history2) => {
  const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(
    featureSearchContextParams,
    setSearchContext,
    ACTION_TYPES.SET_PARTIAL_CONTEXT,
    ACTION_TYPES.SET_CONTEXT,
    // todo: we need to pass in a func that allows us to "find" the user context in the store
    // to be more of a plugin, this method should not "know" this, but rather be passed in
    // this would allow this to be used in the context of an app-module, and its hosting app
    selectFeatureSearchContext,
    history2,
    (pathname) => includes(["/feature-search"], pathname) && !EnvironmentService.useRTKQueryFeatureSearch() && !EnvironmentService.useNewSearchExperience(),
    EXP_QUERY_STRINGS
  );
  return combineEpics(...Object.values(setUserContextFromRouteQueryString));
};
const rootEpic = combineEpics(
  searchFeaturesFromContextEpic,
  searchFeaturesEpicReducer.epic,
  getExperimentationGroupsEpicReducer.epic,
  produceFeatureSearchRouteQueryStringSyncEpics(history)
);
export {
  getExperimentationGroupsEpicReducer,
  rootEpic,
  searchFeaturesEpicReducer
};
//# sourceMappingURL=epics.js.map
